<template>
  <div class="page">
    <div v-if="!this.isMobile()" class="box">
      <h2>请使用微信扫码授权登录</h2>
      <wxlogin class="wxlogin" :appid="pc_appid" :scope="'snsapi_login'" :theme="'black'" :redirect_uri="redirectUrl"
        :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=='"
        rel="external nofollow"></wxlogin>
    </div>
  </div>
</template>
<script>
import wxlogin from 'vue-wxlogin';
export default {
  components: {
    wxlogin
  },
  data() {
    return {
      redirectUrl: '',
      //   appid: 'wx664166dcd706b573',//测试
      appid: this.httphelper.WeChatAppid(),// 'wx710c154c1de7e976',//正式
      pc_appid: 'wx35e9523a1cb0bcfe'
    }
  },
  created() {
    if (this.isMobile()) {
      let baseUrl = this.httphelper.IsDebugH5GP519() + '/pages/login/backpage?callback='
      this.redirectUrl = encodeURIComponent(baseUrl + this.$route.query.url)
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${this.redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    } else {
      this.redirectUrl = this.$route.query.url
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
  }
}
</script>
<style lang="scss" scoped>
.page {
  overflow: hidden;
}

.box {
  width: 300px;
  height: 380px;
  padding: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px auto;
  border: 1px solid #eee;
}
</style>